import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CSSBuySpreadsheetPage from "@/pages/cssbuy-spreadsheet/page";
import CSSBuyReviewPage from "@/pages/cssbuy-review/page";
import CSSBuyShippingPage from "@/pages/cssbuy-shipping/page";
import CSSBuyCouponPage from "@/pages/cssbuy-coupon/page";
import CSSBuyWarehousePage from "@/pages/cssbuy-warehouse/page";
import CSSBuySafetyPage from "@/pages/cssbuy-safety/page";
import PlaceholderPage from "@/pages/PlaceholderPage";
import PillarArticle from "@/components/feature/PillarArticle";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cssbuy-spreadsheet/",
    element: <CSSBuySpreadsheetPage />,
  },
  {
    path: "/cssbuy-review/",
    element: <CSSBuyReviewPage />,
  },
  {
    path: "/cssbuy-shipping/",
    element: <CSSBuyShippingPage />,
  },
  {
    path: "/cssbuy-coupon/",
    element: <CSSBuyCouponPage />,
  },
  {
    path: "/cssbuy-warehouse/",
    element: <CSSBuyWarehousePage />,
  },
  {
    path: "/cssbuy-safety/",
    element: <CSSBuySafetyPage />,
  },
  {
    path: "/cssbuy-finds/",
    element: <PillarArticle slug="cssbuy-finds" />,
  },
  {
    path: "/cssbuy-qc/",
    element: <PillarArticle slug="cssbuy-qc" />,
  },
  {
    path: "/cssbuy-sellers/",
    element: <PillarArticle slug="cssbuy-sellers" />,
  },
  {
    path: "/cssbuy-tutorials/",
    element: <PillarArticle slug="cssbuy-tutorials" />,
  },
  {
    path: "/cssbuy-beginners/",
    element: <PillarArticle slug="cssbuy-beginners" />,
  },
  {
    path: "/cssbuy-payment/",
    element: <PillarArticle slug="cssbuy-payment" />,
  },
  {
    path: "/cssbuy-refund/",
    element: <PillarArticle slug="cssbuy-refund" />,
  },
  {
    path: "/cssbuy-alternatives/",
    element: <PillarArticle slug="cssbuy-alternatives" />,
  },
  {
    path: "/cssbuy-vs-superbuy/",
    element: <PillarArticle slug="cssbuy-vs-superbuy" />,
  },
  {
    path: "/cssbuy-taobao/",
    element: <PillarArticle slug="cssbuy-taobao" />,
  },
  {
    path: "/comparisons/",
    element: <PlaceholderPage title="Comparisons" />,
  },
  {
    path: "/blog/",
    element: <PlaceholderPage title="Blog" />,
  },
  {
    path: "/about/",
    element: <PlaceholderPage title="About" />,
  },
  {
    path: "/editorial-policy/",
    element: <PlaceholderPage title="Editorial Policy" />,
  },
  {
    path: "/contact/",
    element: <PlaceholderPage title="Contact" />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;